import * as Styles from './AlertNotification.styles';

import { Snackbar } from '@mui/material';
import { AlertNotificationProps } from './AlertNotification.types';

function AlertNotification({ open, onClose, alert }: AlertNotificationProps) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{ mt: { xs: 6, md: 1 } }}
    >
      <Styles.UIAlert onClose={onClose} severity={alert?.type} variant="filled">
        {alert?.msg}
      </Styles.UIAlert>
    </Snackbar>
  );
}

export default AlertNotification;
